import type { ProfileImporterComponentProps } from './ProfileImporterComponent';

export const ProfileImporterComponent = {
    MountAsync: async (target: HTMLElement, props: ProfileImporterComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { ProfileImporterComponent } = await import('./ProfileImporterComponent');
        return await mountReactComponentAsync(target, ProfileImporterComponent, props);
    }
};
